import React from 'react';
import { Form } from 'react-bootstrap';

const IntervalSelector = ({ intervalFrequency, setIntervalFrequency, frequency }) => {
  const handleIntervalChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setIntervalFrequency(value);
  };

  return (
    <Form.Group className="mb-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <Form.Label className="fw-bold text-white mb-0 me-2" style={{ minWidth: 50 }}>
          Every
        </Form.Label>
        <div className="flex-row align-items-center d-flex">
          <Form.Control
            type="number"
            min={1}
            value={intervalFrequency}
            onChange={handleIntervalChange}
            className="bg-dark text-white border-secondary w-auto me-2"
            style={{ maxWidth: 80 }}
          />
          <span className="text-white">{frequency}(s)</span>
        </div>
      </div>
    </Form.Group>
  );
};

export default IntervalSelector;
